const propelInit = function() {
const alerts = document.querySelectorAll('.block-alert-bottom');
const cookieName = 'alert-bottom';

if (alerts.length > 0) {
	const setCookie = (name, value, days) => {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		const expires = 'expires=' + date.toUTCString();

		document.cookie =
			name + '=' + JSON.stringify(value) + ';' + expires + ';path=/';
	};

	const getCookie = (name) => {
		const cookieValue = document.cookie.match(
			'(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'
		);

		return cookieValue ? decodeURIComponent(cookieValue.pop()) : null;
	};

	const alertState = JSON.parse(getCookie(cookieName)) || {};

	const setStorage = () => {
		setCookie(cookieName, alertState, 7); // Set cookie with a week expiration
	};

	// display:none can't be transitioned directly, so revealing/hiding is split across two
	// classes: --displayed (added first, forces a layout flush, then --hidden is removed so
	// opacity can animate) and --hidden (removed on show; added on hide, then --displayed is
	// removed once the opacity transition finishes).
	const showAlert = (alert) => {
		alert.classList.add('block-alert-bottom--displayed');
		void alert.offsetWidth;
		alert.classList.remove('block-alert-bottom--hidden');
	};

	const hideAlert = (alert) => {
		alert.classList.add('block-alert-bottom--hidden');

		alert.addEventListener(
			'transitionend',
			(e) => {
				if ('opacity' === e.propertyName) {
					alert.classList.remove('block-alert-bottom--displayed');
				}
			},
			{ once: true }
		);
	};

	alerts.forEach((alert) => {
		if (!alert.id) {
			return;
		}

		const alertID = alert.id;

		const alertCloseButton = alert.querySelector(
			'.block-alert-bottom__close-button'
		);

		//Close alert item and set cookie
		if (alertCloseButton) {
			alertCloseButton.addEventListener('click', function (e) {
				e.preventDefault();
				hideAlert(alert);
				alertState[alertID] = { viewed: true };
				setStorage();
			});
		}

		//No cookie, set all to not viewed
		if (!alertState[alertID]) {
			alertState[alertID] = { viewed: false };
			showAlert(alert);
			setStorage();

			return;
		}

		if (alertState[alertID].viewed) {
			alert.classList.add('block-alert-bottom--hidden');
		} else {
			showAlert(alert);
		}
	});
}

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['alert-bottom'] = window.propel.blocks['alert-bottom'] || {};
window.propel.blocks['alert-bottom'].script = propelInit;
